<template>
    <div class="mb10 order__radio-group-block">
        <input type="hidden" name="OrderForm[pay_type]" value="0" />
        <template v-for="(pay_type, i) in local_pay_types">
        <input v-model="pay_selected" v-on:change="setPayType()" class="order__radio" :id="i" name="OrderForm[pay_type]" :value="i" type="radio" checked="checked"/>
        <label class="order__radio-label-block" :for="i">
            <span class="order__radio-fake mb10">
                <span class="order__radio-name"v-html="pay_type.name"></span>
            </span>
            <span class="order__radio-term mb5" v-html="pay_type.description_short"></span>
            <!--<span class="order__radio-note order__radio-note--red">Скидка 500р</span>-->
            <img class="order__radio-img" :src="localBaseUrl + '/img/payment/' + i + '.png'" alt=""/>
        </label>
        </template>
    </div>
</template>

<script>
    export default {
        name: "select-payment",
        props: {
            pay_types: {
                type: Object
            },
            pay_type: {
                type: String
            },
            baseurl: {
                type: String
            }
        },
        data () {
            return {
                pay_selected: this.pay_type,
                local_pay_types: this.pay_types,
                localBaseUrl: this.baseurl
            }
        },
        methods: {
            setPayType () {
                this.$store.dispatch('setPayType', this.pay_selected)
            }
        },
        mounted() {
            this.setPayType();
        }
    }
</script>

<style scoped>

</style>
